import api from './axiosClient'
import {AppDispatch} from "../../store";
import {saveUserExpressions} from "../../reducer/security.reducer";
import {SecurityExpression} from "../../proto/generated/security";
import {UserSecurityExpressions} from "../../proto/generated/user-preference";

export const saveSecurityExpression = async (args : {
                    expression: SecurityExpression
                }): Promise<SecurityExpression> => {
    return new Promise((resolve, reject) => {
        const url = `/user-security-expression`
        api.post(url, JSON.stringify(args.expression), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.expression),
            responseType: 'arraybuffer'
        }).then( async(response) => {
            const decodedData = SecurityExpression.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}

export const refreshSecurityExpressions = async (args : {securityExpressions: SecurityExpression[]}): Promise<UserSecurityExpressions> => {
    return new Promise((resolve, reject) => {
        const url = `/user-security-expression/refresh`
        api.post(url, JSON.stringify({
            securityExpressions: args.securityExpressions
        }), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then( async(response) => {
            const decodedData = UserSecurityExpressions.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}

export const renameSecurityExpression = async (args : {
    expressionId: string,
    name: string
}): Promise<SecurityExpression> => {
    return new Promise((resolve, reject) => {
        const url = `/user-security-expression/${args.expressionId}/rename`
        api.post(url, {}, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            params: {
                name: args.name
            },
            responseType: 'arraybuffer'
        }).then( async(response) => {
            const decodedData = SecurityExpression.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}

export const deleteSecurityExpression = async (args : {
    expression: SecurityExpression
}): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/user-security-expression`
        api.delete(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.expression),
            responseType: 'arraybuffer'
        }).then( async(response) => {
            resolve()
        }).catch((error) => {
            reject(error)
        });
    })
}

export const getAllUserExpressions = async (args : { dispatch: AppDispatch}): Promise<UserSecurityExpressions> => {
    return new Promise((resolve, reject) => {
        const url = `/user-security-expression`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then( async(response) => {
            const decodedData = UserSecurityExpressions.decode(new Uint8Array(response.data))
            args.dispatch(saveUserExpressions(decodedData.securityExpressions))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}

